import { Grid, makeStyles, Theme } from "@material-ui/core";
import React from "react";
import { RecordHeader } from "@ofqual/portal-components/components/RecordHeader";
import { NonNullableItemState } from "../../redux/state";
import { InformationRequestStatus } from "../../domain/InformationRequest";
import {
  formatUtcDate,
  standardDateFormats,
} from "@ofqual/portal-core/core/utils/dateUtils";
import { useValidation } from "../../hooks/useValidation";
import { ItemValidation } from "./ItemValidation";

const useStyles = makeStyles((theme: Theme) => {
  return {
    gridItem: {
      borderRight: "1px solid rgba(255,255,255,0.2)",
      //padding: "0 15px",
      "& div": {
        paddingBottom: "5px",
      },
    },
  };
});

type ItemHeaderProps = {
  state: NonNullableItemState | null;
};

export const ItemHeader: React.FC<ItemHeaderProps> = ({ state }) => {
  const classes = useStyles();
  const validation = useValidation();

  return (
    <RecordHeader>
      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="stretch"
        spacing={2}
        style={{ height: "100%" }}
      >
        <Grid className={classes.gridItem} item>
          <div>
            <label>
              <strong>Created By: </strong>
            </label>
            <span data-test="metadata-created-by">
              {state?.item.createdByDisplayName}
            </span>
          </div>
          <div>
            <label>
              <strong>Created At: </strong>
            </label>
            <span data-test="metadata-created-date">
              {formatUtcDate(
                state?.item.createdDate,
                standardDateFormats.DATE_TIME
              )}
            </span>
          </div>
          <div>
            <label>
              <strong>Status: </strong>
            </label>
            <span data-test="metadata-status">
              {state ? InformationRequestStatus[state.item.status] : ""}
            </span>
          </div>
        </Grid>

        {state?.item.modifiedByDisplayName && state?.item.modifiedDate ? (
          <Grid className={classes.gridItem} item>
            <div>
              <label>
                <strong>Updated By: </strong>
              </label>
              <span data-test="metadata-updated-by">
                {state?.item.modifiedByDisplayName}
              </span>
            </div>
            <div>
              <label>
                <strong>Updated At: </strong>
              </label>
              <span data-test="metadata-updated-date">
                {formatUtcDate(
                  state?.item.modifiedDate,
                  standardDateFormats.DATE_TIME
                )}
              </span>
            </div>
          </Grid>
        ) : null}

        {validation.isReady && !validation.isOk && (
          <Grid item style={{ marginLeft: "auto" }}>
            <ItemValidation validation={validation} />
          </Grid>
        )}
      </Grid>
    </RecordHeader>
  );
};
